import React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {
  FitType,
  Label,
  RiveFitSelect,
} from '@packages/systems/ui/shared-ui/Rive';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {useRiveContext} from './RiveContext';
import {getString} from '@packages/utilities/json';
import {VStack} from '@packages/systems/spring';

const id = 'rive-fit-input';
const label = 'Fit';

export const fit = TypeImplementation.Custom({
  render: function FitInput({expr}) {
    const {selectFit, hasInstance} = useRiveContext();
    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal ? (getString(literal.value) as FitType) : undefined;

    return (
      <VStack spacing={1}>
        <Label id={`rive-settings-rive-${label}-select-label`} htmlFor={id}>
          {label}
        </Label>
        <RiveFitSelect
          aria-label={label}
          data-automation-id={id}
          aria-labelledby={`rive-settings-${label}-select-label`}
          value={state}
          isDisabled={!hasInstance}
          onChange={selectFit}
        />
      </VStack>
    );
  },
  system: {
    labelVariant: 'hidden',
  },
});
